// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 826) return "static/chunks/826.affe0987fe6a1a7e.js";
	if (chunkId === 46) return "static/chunks/46.bce53ed056a661ae.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"360":"523d46cd54bcfa49","431":"29564a12b8cca8e4","484":"c3aaa499d97a27c1","939":"f2f401be936cc790"}[chunkId] + ".js";
};